import React from 'react';
import Icon from '@uiw/react-icon';
import { jsx as _jsx } from "react/jsx-runtime";
export function IconProgress(props) {
  return /*#__PURE__*/_jsx(Icon, {
    type: props.type
  });
}